interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function getPages(current: number, total: number): (number | "ellipsis")[] {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages: (number | "ellipsis")[] = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push("ellipsis");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push("ellipsis");
  pages.push(total);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = getPages(page, totalPages);

  return (
    <nav className="flex items-center justify-center gap-1.5 flex-wrap" aria-label="分页">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="h-10 px-3 flex items-center justify-center gap-1 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
      >
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-arrow-left-s-line"></i>
        </span>
        上一页
      </button>

      {pages.map((p, idx) =>
        p === "ellipsis" ? (
          <span key={`e-${idx}`} className="w-9 h-10 flex items-center justify-center text-foreground-400">
            …
          </span>
        ) : (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`min-w-10 h-10 px-3 flex items-center justify-center rounded-md text-sm transition-colors cursor-pointer ${
              p === page
                ? "bg-primary-500 text-background-50 font-medium"
                : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-400 hover:text-primary-700"
            }`}
          >
            {p}
          </button>
        ),
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="h-10 px-3 flex items-center justify-center gap-1 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
      >
        下一页
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-arrow-right-s-line"></i>
        </span>
      </button>
    </nav>
  );
}